import { render, staticRenderFns } from "./SpecificationDashboard.vue?vue&type=template&id=5aa489c6"
import script from "./SpecificationDashboard.vue?vue&type=script&lang=js"
export * from "./SpecificationDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports